import {useMutation} from '@tanstack/react-query';
import {apiClient, queryClient} from '../../http/query-client';
import {BackendResponse} from '../../http/backend-response/backend-response';
import {toast} from '@ui/toast/toast';
import {DatatableDataQueryKey} from './paginated-resources';
import {useDataTable} from '../page/data-table-context';
import {message} from '@ui/i18n/message';
import {showHttpErrorToast} from '../../http/show-http-error-toast';
import {Key} from 'react';

interface Response extends BackendResponse {
  // Propriétés spécifiques de la réponse (si nécessaire)
}

export function useValidationSelectedRows(validation: string) {
  const {endpoint, selectedRows, setSelectedRows} = useDataTable();
  return useMutation<Response, unknown, any>({
    // La fonction mutationFn reçoit un argument qui peut être soit une chaîne pour accept, soit un objet pour deny.
    mutationFn: (reason: any) =>
      validationSelectedRows(endpoint, selectedRows, validation, reason),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: DatatableDataQueryKey(endpoint),
      });
      toast(
        message(
          (validation === 'accept' ? 'Accepted' : 'Denied') +
            ' [one 1 record|other :count records]',
          {
            values: {count: selectedRows.length},
          },
        ),
      );
      setSelectedRows([]);
    },
    onError: err =>
      showHttpErrorToast(err, message('Could not delete records')),
  });
}

function validationSelectedRows(
  endpoint: string,
  ids: Key[],
  validation: string,
  reason: any,
): Promise<Response> {
  return apiClient
    .post(`${endpoint}/${ids.join(',')}`, {
      validation: validation,
      raison: reason,
    })
    .then(r => r.data);
}
